import { render, staticRenderFns } from "./thong-ke-hoa-hong-nhan-vien.vue?vue&type=template&id=62bdffa5&"
import script from "./thong-ke-hoa-hong-nhan-vien.vue?vue&type=script&lang=js&"
export * from "./thong-ke-hoa-hong-nhan-vien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports